import { NgModule } from '@angular/core';
import { MuiSidebarPageContent } from './sidebar/mmu-sidebar-page-content.component';
import { MuiSidebarPageSidebar } from './sidebar/mmu-sidebar-page-sidebar.component';
import { MuiSidebarPage } from './sidebar/mmu-sidebar-page.component';


@NgModule({
  declarations: [MuiSidebarPage, MuiSidebarPageContent, MuiSidebarPageSidebar],
  exports: [MuiSidebarPage, MuiSidebarPageSidebar, MuiSidebarPageContent]
})
export class MuiLayoutModule {}
